import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './HouseInfo.scss';
import Slider from 'react-slick';
import ImageModal from '../ImageModal/ImageModal';

const HouseInfo = ({ text, image, carouselImages = [] }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState('');

  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const handleImageModalOpen = (imageUrl) => {
    setShowModal(true);
    setSelectedImageUrl(imageUrl)
  };

  const renderSlides = () => {
    return carouselImages.map((imageUrl) => {
      return (
        <div
          className='house-info__carousel--slide'
          onClick={() => handleImageModalOpen(imageUrl)}
        >
          <div
            className='house-info__carousel--image'
            style={{ backgroundImage: `url("${imageUrl}")` }}
          />
        </div>
      )
    })
  };

  return (
    <div className='house-info'>
      <Container>
        <Row>
          <Col lg={5}>
            <img className='house-info__img' alt='' src={image} />
          </Col>
          <Col lg={{ span: 5, offset: 2 }}>
            <div className='house-info__text-wrapper'>
              <p className='house-info__text'>{text}</p>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Slider
              className='house-info__carousel'
              {...settings}
            >
              {renderSlides()}
            </Slider>
          </Col>
        </Row>
      </Container>
      <ImageModal
        show={showModal}
        imageUrl={selectedImageUrl}
        handleClose={() => setShowModal(false)}
      />
    </div>
  )
};

export default HouseInfo;
